<div #stickyPanel
     class="td-wb-sticky-observer__panel"
     [style.top]="getTop()"></div>
